export interface RoleClass {
    AccountRoleId: number
    AccountId: number
    Role: string
    LDAPRole: string
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    IsDeleted: boolean
    IsDisabled: boolean
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    isSelected:number
}

export const roleInitialsForApp = {
    Role: "",
    LDAPRole: "",
    IsDisabled:false
}

export const roleInitialsForUpdate = {
    Role: "",
    LDAPRole: "",
    AccountRoleId: "",
    IsDisabled:false
}